import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
const ErrorPage = React.lazy(() => import("../components/error-page"));
const CasoDetalle = React.lazy(() => import("../screean/case/caso-detalle"));

export function casoDetalle() {
  return (
    <Route
      path="/caso-detalle"
      element={
        <ProtectedRoute>
          <LazySuspense>
            <CasoDetalle />
          </LazySuspense>
        </ProtectedRoute>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
